import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import classes from './tabs.module.scss';

const tableHeader = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'UserName',
    path: 'username',
  },
  {
    name: 'Email',
    path: 'email',
  },
];

const User = () => {
  const { patient } = useSelector((store) => store.patients);

  return (

    <div className={classes.user_wrapper}>
      {patient.userData
        ? (
          <div className={classes.table_wrapper}>

            <table>

              <thead>
                <tr>
                  {tableHeader.map((h) => (
                    <th key={h.name}>{h.name}</th>
                  ))}
                </tr>
              </thead>

              <tbody>

                <tr>
                  {tableHeader.map((h) => (
                    <td key={h.name}>{_.get(patient.userData, h.path) || '-'}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        )
        : <div className={classes.notResult}>No Data Found</div>}
    </div>

  );
};

export default User;
